import React from "react";
import { BtnContainer, Container } from "./styles";
import CloseIcon from "@mui/icons-material/Close";

function PopupPDFEquipamento({dataPdf, props, back}) {
  return (
    <Container>
      <BtnContainer>
        <CloseIcon className="text-blue-600 hover:bg-gray-300 cursor-pointer rounded-[8px]" onClick={() => back()} style={{ width: 30 }} />
      </BtnContainer>
      <iframe
        src={`data:application/pdf;base64,${dataPdf.blob}`}
        height="80%"
        width="80%"
      />
    </Container>
  );
}

export default PopupPDFEquipamento;
